import gql from 'graphql-tag';

export const getNoteTypes = gql`
  query getNoteTypes {
    getNoteTypes {
      id
      name
      createdBy
      createdDate
      updatedBy
      updatedDate
      version
      active
      aors {
        id
        name
      }
      Categories {
        id
        name
      }
    }
  }
`;
